import { ReactNode } from 'react';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import { FlagName } from '../../utils/flags.gen';

interface FeatureFlagProps {
  flag: FlagName;
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Inline render gate: shows `children` only when `flag` is enabled for the
 * current user. Use for conditionally rendering UI; use {@link FeatureFlagGuard}
 * to gate whole routes.
 */
export function FeatureFlag({ flag, children, fallback = null }: FeatureFlagProps) {
  const { isEnabled } = useFeatureFlags();

  return <>{isEnabled(flag) ? children : fallback}</>;
}

export default FeatureFlag;
